import messages from './onboarding.json' with { type: 'json' };

export const onboardingSv: Readonly<typeof messages> = messages;
